import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/axios';
import alertService from '../services/alerts';
import '../styles/ForgotPasswordPage.css';
import logo from '../assets/elon_logo.png';

function ForgotPasswordPage() {
  const [correo, setCorreo] = useState('');
  const [mensaje, setMensaje] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMensaje('');
    setError('');
    setIsLoading(true);

    try {
      await api.post('/auth/forgot-password', { correo });
      await alertService.success(
        'Correo Enviado',
        'Correo de restablecimiento enviado, revisa tu bandeja.'
      );

      setTimeout(() => {
        navigate('/verify-token');
      }, 2000);
    } catch (err) {
      let errorMessage = 'Error o correo no registrado';
      
      if (err.response && err.response.data && err.response.data.error) {
        errorMessage = err.response.data.error;
      }
      
      await alertService.error('Error', errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  const handleGoBack = () => {
    navigate('/login');
  };

  return (
    <div className="forgot-password-bg">
      <div className="forgot-password-card">
        <img 
          src={logo} 
          alt="Elon School Logo" 
          className="forgot-password-logo"
          loading="lazy"
        />

        <h1 className="forgot-password-title">Recuperar Contraseña</h1>
        
        {error && (
          <div className="forgot-password-error-message" role="alert">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} noValidate>
          <div className="forgot-password-form-group">
            <label htmlFor="email">Correo Electrónico</label>
            <input
              id="email"
              type="email"
              value={correo}
              onChange={(e) => setCorreo(e.target.value)}
              placeholder="ejemplo@correo.com"
              required
              autoComplete="email"
              aria-describedby={error ? "error-message" : undefined}
            />
          </div>

          <div className="forgot-password-button-group">
            <button 
              type="button" 
              className="forgot-password-btn-back" 
              onClick={handleGoBack}
              disabled={isLoading}
            >
              Regresar
            </button>
            <button 
              type="submit" 
              className="forgot-password-btn-submit"
              disabled={isLoading}
            >
              {isLoading ? 'Enviando...' : 'Enviar'}
            </button>
          </div>
        </form>

        {mensaje && (
          <div className="forgot-password-success-message" role="status">
            {mensaje}
          </div>
        )}
      </div>
    </div>
  );
}

export default ForgotPasswordPage;
